/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Object } from 'core-js';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  manufacturerIdLabel,
  nameLabel,
  rebateProgramLabel,
  quarterRangeLabel,
  unallocatedBalanceLabel,
  URAUsedLabel,
  ARmanufacturerLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import { ARManufacturerColumns } from '../tablehead';
import ActionDropDownComp from '../ActionDropdownComp';
import * as actiontype from './store/actiontypes';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  manufacturerArTbl,
  getUnallocatedMfg,
  getManuARForSglRpc,
  fldValueUpdate,
  showSelectAction,
  getAccRecNDCSingleData,
  getAccRecNDCAllData,
  mfgARFirstLoad,
} from './store/actions';
import * as AR_CONST from '../AccountsRevConstants';
import {
  getExistingCorrLinkIds,
  goToArMfg,
  getInvoiceDetails,
  updateInvoiceBalanced,
  undoInvoiceBalanced,
  updateInvoiceBankrupt,
  undoInvoiceBankrupt,
  goToArSummaryAccRecNDCSingle,
  goToArSummaryAccRecNDCAll,
} from '../ARCommonFunctions';
import RedTextRenderComp from '../RedTextRenderComp';
import {
  compareQtrs,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { arMfgFirstLoadAction } from '../ARManufacturer/store/actions';
import {
  dispatchNDCBalanceDue,
  dispatchNDCOveridden,
  dispatchNDCPaidInFull,
  ndcDetailFirstLoadAction,
} from '../AccRecNDCDetail/store/actions';
import {
  checkActionAccessByRole,
  checkNumber,
} from '../../../../SharedModules/utilities/utilities';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

const MfgAccountsRec = (props) => {
  const dispatch = useDispatch();
  const [fullScreen, setFullScreen] = React.useState(false);
  const [tblRecord, setTblRecord] = React.useState([]);
  const [colHeader, setColHeader] = React.useState([]);
  const [pinned, setPinned] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [confimPopup, setConfimPopup] = React.useState(false);
  const [confirmPopupData, setConfirmPopupData] = React.useState({
    callFrom: '',
    popupText: '',
  });
  const [undoData, setUndoData] = React.useState({});
  const [dialogText, setDialogText] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [arNavRebate, setArNavRebate] = React.useState();
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );

  const activeMfgPgmCode = `${
    props?.location?.state?.mfgId
      ? props?.location?.state?.mfgId
      : props?.location?.value?.state?.mfgId
  }-${
    props?.location?.state?.rebateProgram
      ? props?.location?.state?.rebateProgram
      : props?.location?.value?.state?.rebateProgram
  }`;
  const { ar_manu, mfgndc_sgl, mfgndc_all, mfgArFirstLoad } = useSelector(
    (state) => state?.sharedState?.ManufacturerArReducer
  );
  const find_manu_artbl = useSelector((state) =>
    state?.sharedState?.ManufacturerArReducer?.manu_artbl?.find((obj) => {
      return obj[activeMfgPgmCode];
    })
  );
  const manu_artbl = find_manu_artbl?.[activeMfgPgmCode];
  const find_manu_arfld = useSelector((state) =>
    state?.sharedState?.ManufacturerArReducer?.manu_arfld?.find((obj) => {
      return obj[activeMfgPgmCode];
    })
  );
  const manu_arfld = find_manu_arfld?.[activeMfgPgmCode];
  const find_unallocated = useSelector((state) =>
    state?.sharedState?.ManufacturerArReducer?.unallocated?.find((obj) => {
      return obj[activeMfgPgmCode];
    })
  );
  const unallocated = find_unallocated?.[activeMfgPgmCode]
    ? find_unallocated?.[activeMfgPgmCode]
    : 0;
  const { rbt_list } = useSelector(
    (state) => state?.sharedState?.AccountRecReducer
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const selectedRebate = (val) => {
    setArNavRebate(val.rebateProgramCd);
    const payload = {
      planType: val.planTypeCd,
      mfgId: manu_arfld.mfgId,
      startQtr: manu_arfld.startQtr,
      endQtr: manu_arfld.endQtr,
      useOfficialURA: manu_arfld.useOfficialURA,
      rebateProgram: val.rebateProgramCd,
    };
    dispatch(
      getManuARForSglRpc(payload, {
        ...manu_arfld,
        ...payload,
        pgmCd: val.rebateProgramCd,
        pgmInfo: `${val.rebateProgramCd} | ${val.shortDescr}`,
      })
    );
    setLoad(true);
  };

  const commentsData = (status, id) => {
    setShowComments(status);
    setCorrLinkId(id);
  };

  const updateInvoiceBalancedHandler = (data) => {
    setLoad(true);
    getInvoiceDetails(data.data.invoiceNum).then((invDtl) => {
      setLoad(false);
      if (invDtl) {
        if (
          data.data.invoiceStatus === 'DB' ||
          data.data.invoiceStatus === 'DBK'
        ) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceDeclaredBalancedMsg);
        } else if (!invDtl?.invoiceFreezeDt) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceFrozen);
        } else if (data.data.invoiceStatus === 'FG') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceIsForgivenMsg);
        } else if (data.data.invoiceStatus === 'WO') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceWrittenOffMsg);
        } else {
          const payloadData = {
            invoiceStatusCd: data.data.invoiceStatus,
            invoiceNum: data.data.invoiceNum,
            rebateProgramCd: manu_arfld?.pgmCd,
            invoiceQtr: data.data.qtr,
          };
          updateInvoiceBalanced(payloadData).then((res) => {
            if (res && res.data.status === '001') {
              setIsDialogOpen(true);

              if (res.data.response.invoiceStatus === 'DB') {
                if (manu_arfld.pgmInfo.indexOf('All') !== -1) {
                  const updatedStatusData = manu_artbl.summaryList.map(
                    (item) => {
                      if (item.invoiceNum === data.data.invoiceNum)
                        item.invoiceStatus = 'DB';
                      return item;
                    }
                  );
                  let manuFactuData = {
                    [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                      ...manu_artbl,
                      summaryList: updatedStatusData,
                    },
                  };
                  dispatch(manufacturerArTbl(manuFactuData));
                } else {
                  const updatedStatusData = manu_artbl.infoList.map((item) => {
                    if (item.invoiceNum === data.data.invoiceNum)
                      item.invoiceStatus = 'DB';
                    return item;
                  });
                  let manuFactuData = {
                    [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                      ...manu_artbl,
                      infoList: updatedStatusData,
                    },
                  };
                  dispatch(manufacturerArTbl(manuFactuData));
                }
                if (gridApi) gridApi.api.refreshCells();
                setDialogText(AR_CONST.invoiceBalanceCompleted);
              } else {
                setDialogText(res.data.response.responseMessage);
              }
            } else {
              setIsDialogOpen(true);
              setDialogText(AR_CONST.invoiceBalanceFailed);
            }
          });
        }
      }
    });
  };

  const undoInvoiceBalancedHandler = (data) => {
    if (data.data.invoiceStatus === 'FG') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoForgivenMsg);
    } else if (data.data.invoiceStatus === 'WO') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoWrittenOff);
    } else if (
      data.data.invoiceStatus !== 'DB' &&
      data.data.invoiceStatus !== 'DBK'
    ) {
      // show confirmation popup
      setConfimPopup(true);
      setConfirmPopupData({
        callFrom: 'balance',
        popupText: AR_CONST.undoDeclareBalanced,
      });
      setUndoData(data);
    } else {
      const payloadData = {
        invoiceStatusCd: data.data.invoiceStatus,
        invoiceNum: data.data.invoiceNum,
        rebateProgramCd: manu_arfld?.pgmCd,
        invoiceQtr: data.data.qtr,
      };

      undoInvoiceBalanced(payloadData).then((res) => {
        if (res && res.data.response) {
          // Update table grid store
          if (manu_arfld.pgmInfo.indexOf('All') !== -1) {
            const updatedStatusData = manu_artbl.summaryList.map((item) => {
              if (item.invoiceNum === data.data.invoiceNum)
                item.invoiceStatus = res.data.response?.invoiceStatus;
              return item;
            });
            let manuFactuData = {
              [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                ...manu_artbl,
                summaryList: updatedStatusData,
              },
            };
            dispatch(manufacturerArTbl(manuFactuData));
          } else {
            const updatedStatusData = manu_artbl.infoList.map((item) => {
              if (item.invoiceNum === data.data.invoiceNum)
                item.invoiceStatus = res.data.response?.invoiceStatus;
              return item;
            });
            let manuFactuData = {
              [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                ...manu_artbl,
                infoList: updatedStatusData,
              },
            };
            dispatch(manufacturerArTbl(manuFactuData));
          }
          if (gridApi) gridApi.api.refreshCells();

          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedFailed);
        }
      });
    }
  };

  const declareInvoiceBankruptHandler = (data) => {
    setLoad(true);
    getInvoiceDetails(data.data.invoiceNum).then((invDtl) => {
      setLoad(false);
      if (invDtl) {
        if (data.data.invoiceStatus === 'DBK') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceAlreadyBankrupt);
        } else if (!invDtl?.invoiceFreezeDt) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptFrozon);
        } else if (data.data.invoiceStatus === 'FG') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptForgiven);
        } else if (data.data.invoiceStatus === 'WO') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptWrittenOff);
        } else if (data.data.invoiceStatus === 'DB') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptBalanced);
        } else {
          const payloadData = {
            invoiceStatusCd: data.data.invoiceStatus,
            invoiceNum: data.data.invoiceNum,
            rebateProgramCd: manu_arfld?.pgmCd,
            invoiceQtr: data.data.qtr,
          };
          updateInvoiceBankrupt(payloadData).then((res) => {
            if (res && res.data?.status === '001') {
              setIsDialogOpen(true);

              if (res.data?.response?.invoiceStatus === 'DBK') {
                if (manu_arfld.pgmInfo.indexOf('All') !== -1) {
                  const updatedStatusData = manu_artbl.summaryList.map(
                    (item) => {
                      if (item.invoiceNum === data.data.invoiceNum)
                        item.invoiceStatus = 'DBK';
                      return item;
                    }
                  );
                  let manuFactuData = {
                    [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                      ...manu_artbl,
                      summaryList: updatedStatusData,
                    },
                  };
                  dispatch(manufacturerArTbl(manuFactuData));
                } else {
                  const updatedStatusData = manu_artbl.infoList.map((item) => {
                    if (item.invoiceNum === data.data.invoiceNum)
                      item.invoiceStatus = 'DBK';
                    return item;
                  });
                  let manuFactuData = {
                    [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                      ...manu_artbl,
                      infoList: updatedStatusData,
                    },
                  };
                  dispatch(manufacturerArTbl(manuFactuData));
                }
                if (gridApi) gridApi.api.refreshCells();
                setDialogText(AR_CONST.invoiceBankruptCompleted);
              } else {
                setDialogText(res.data?.response?.responseMessage);
              }
            } else {
              setIsDialogOpen(true);
              setDialogText(AR_CONST.invoiceBankruptFailed);
            }
          });
        }
      }
    });
  };

  const undoDeclareInvoiceBankruptHandler = (data) => {
    if (data.data.invoiceStatus === 'FG') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptForgiven);
    } else if (data.data.invoiceStatus === 'WO') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptWrittenOff);
    } else if (data.data.invoiceStatus === 'DB') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptBalanced);
    } else if (data.data.invoiceStatus !== 'DBK') {
      // show confirmation popup
      setConfimPopup(true);
      setConfirmPopupData({
        callFrom: 'bankrupt',
        popupText: AR_CONST.undoInvoiceBankruptConfirmMsg,
      });
      setUndoData(data);
    } else {
      const payloadData = {
        invoiceStatusCd: data.data.invoiceStatus,
        invoiceNum: data.data.invoiceNum,
        rebateProgramCd: manu_arfld?.pgmCd,
        invoiceQtr: data.data.qtr,
      };

      undoInvoiceBankrupt(payloadData).then((res) => {
        if (res && res.data?.response) {
          // Update table grid store
          if (manu_arfld.pgmInfo.indexOf('All') !== -1) {
            const updatedStatusData = manu_artbl.summaryList.map((item) => {
              if (item.invoiceNum === data.data.invoiceNum)
                item.invoiceStatus = res.data.response?.invoiceStatus;
              return item;
            });
            let manuFactuData = {
              [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                ...manu_artbl,
                summaryList: updatedStatusData,
              },
            };
            dispatch(manufacturerArTbl(manuFactuData));
          } else {
            const updatedStatusData = manu_artbl.infoList.map((item) => {
              if (item.invoiceNum === data.data.invoiceNum)
                item.invoiceStatus = res.data.response?.invoiceStatus;
              return item;
            });
            let manuFactuData = {
              [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: {
                ...manu_artbl,
                infoList: updatedStatusData,
              },
            };
            dispatch(manufacturerArTbl(manuFactuData));
          }
          if (gridApi) gridApi.api.refreshCells();

          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoInvoiceBankruptCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoInvoiceBankruptFailed);
        }
      });
    }
  };

  const frameworkComponents = {
    ActionRenderer: (cellInfo) => {
      const show_select = useSelector(
        (state) => state?.sharedState?.ManufacturerArReducer.show_select
      );
      const find_manu_arfld = useSelector((state) =>
        state?.sharedState?.ManufacturerArReducer?.manu_arfld?.find((obj) => {
          return obj[activeMfgPgmCode];
        })
      );
      const manu_arfld = find_manu_arfld?.[activeMfgPgmCode];
      return (
        <>
          <div className="tdCell dib icon-btn-group mfgarbtn">
            {hasAccess && manu_arfld?.pgmInfo.indexOf('All') === -1 && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
              >
                <Button
                  onClick={() => commentsData(true, cellInfo.data.corrLinkId)}
                  variant="text"
                  aria-label="comment"
                  className="th-ic comment-ic frr-disabled-comment-btn"
                >
                  {!cellInfo.data.cc_COMMENTS_EXIST ? (
                    <SVGComponent iconName="Icon-comment-grey" />
                  ) : (
                    <SVGComponent iconName="Icon-comment" />
                  )}
                </Button>
              </OverlayTrigger>
            )}
            <ActionDropDownComp
              data={cellInfo}
              loadfn={setLoad}
              displayBy="mfgAr"
              extraData={manu_arfld}
              handleGoToAccRecNDCDetail={handleGoToAccRecNDCDetail}
              selectPgm={show_select}
              selectedRebate={selectedRebate}
              updateInvoiceBalancedHandler={updateInvoiceBalancedHandler}
              undoInvoiceBalancedHandler={undoInvoiceBalancedHandler}
              declareInvoiceBankruptHandler={declareInvoiceBankruptHandler}
              undoDeclareInvoiceBankruptHandler={
                undoDeclareInvoiceBankruptHandler
              }
            />
          </div>
        </>
      );
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    InvoiceDateRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return cellInfo.value;
    },
    CheckboxRenderer: (cellInfo) => {
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            value={cellInfo.data.ccLetterSent === 0 ? false : true || false}
            disabled
            onChange={(e, val) => {}}
            checked={cellInfo.data.ccLetterSent === 0 ? false : true || false}
          />
        </div>
      );
    },
  };

  const commentsCallFn = async () => {
    const val = manu_artbl.infoList.map((o) => o.corrLinkId);
    const result = await dispatch(getExistingCorrLinkIds(val));
    let newVal = manu_artbl.infoList.map((obj) => {
      obj.cc_COMMENTS_EXIST = 0;
      if (result.indexOf(obj.corrLinkId) !== -1) obj.cc_COMMENTS_EXIST = 1;
      return obj;
    });
    newVal = { ...manu_artbl, infoList: newVal };
    let manuFactuData = {
      [`${manu_arfld?.mfgId}-${manu_arfld?.rebateProgram}`]: newVal,
    };
    dispatch(manufacturerArTbl(manuFactuData));
    if (gridApi) gridApi.api.redrawRows();
  };

  const onGridReady = (params) => {
    setGridApi(params);
  };

  const renderTooltip = (propsTooltip) => {
    return manu_arfld?.qtrInfo.indexOf('DRAMS') !== -1 ||
      manu_arfld?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {manu_arfld?.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const handleGoToAccRecNDCDetail = (row) => {
    if (row) {
      setLoad(true);
      const obj = { ...row.data, ...manu_arfld };
      if (manu_arfld.pgmInfo.indexOf('All') === -1) {
        const payload = {
          mfgId: manu_arfld.mfgId,
          startQuarter: row.data.qtr,
          aiUseOfficialURA: manu_arfld.useOfficialURA,
          invoiceNumber: parseInt(row.data.invoiceNum),
          rebateProgramCd: manu_arfld?.pgmCd,
        };
        dispatch(getAccRecNDCSingleData(payload, obj));
        if (UserDefaultValues) {
          if (UserDefaultValues?.dispBalanceDueNdcInd != 0)
            dispatch(
              dispatchNDCBalanceDue({
                [payload.rebateProgramCd]: true,
              })
            );
          else
            dispatch(
              dispatchNDCBalanceDue({
                [payload.rebateProgramCd]: false,
              })
            );
          if (UserDefaultValues?.dispOverriddenNdcInd != 0)
            dispatch(
              dispatchNDCOveridden({
                [payload.rebateProgramCd]: true,
              })
            );
          else
            dispatch(
              dispatchNDCOveridden({
                [payload.rebateProgramCd]: false,
              })
            );
          if (UserDefaultValues?.dispPaidInFullNdcInd != 0)
            dispatch(
              dispatchNDCPaidInFull({
                [payload.rebateProgramCd]: true,
              })
            );
          else
            dispatch(
              dispatchNDCPaidInFull({
                [payload.rebateProgramCd]: false,
              })
            );
        } else {
          dispatch(
            dispatchNDCBalanceDue({
              [payload.rebateProgramCd]: true,
            })
          );
          dispatch(
            dispatchNDCOveridden({
              [payload.rebateProgramCd]: true,
            })
          );
          dispatch(
            dispatchNDCPaidInFull({
              [payload.rebateProgramCd]: false,
            })
          );
        }
      } else {
        const payload = {
          mfgId: manu_arfld.mfgId,
          startQuarter: row.data.qtr,
          aiUseOfficialURA: manu_arfld.useOfficialURA,
        };
        dispatch(getAccRecNDCAllData(payload, obj));
      }
    }
  };

  const getBgHighlighterColor = (obj) => {
    let bgColor = '';
    if (
      obj.invoiceStatus === 'DB' ||
      obj.invoiceStatus === 'FG' ||
      obj.invoiceStatus === 'WO' ||
      obj.invoiceStatus === 'DBK'
    ) {
      bgColor = 'green-legend';
    } else if (obj.actions === 'hide') {
      bgColor = 'd-none';
    } else if (obj.drams && obj.qtr && compareQtrs(obj.drams, obj.qtr)) {
      bgColor = 'yellow-legend';
    }
    return bgColor;
  };

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
    }
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    if (mfgndc_sgl) {
      if (mfgndc_sgl.status === '001' && mfgndc_sgl.message === 'SUCESS') {
        goToArSummaryAccRecNDCSingle(props.history, manu_arfld.pgmCd, dispatch);
        dispatch(ndcDetailFirstLoadAction(false));
        dispatch({ type: actiontype.NDC_DETAIL_SIGNLE_MFG, payload: null });
      }
    }
  }, [mfgndc_sgl]);

  React.useEffect(() => {
    if (mfgndc_all) {
      if (mfgndc_all.status === '001' && mfgndc_all.message === 'SUCESS') {
        goToArSummaryAccRecNDCAll(props.history, dispatch);
        dispatch({ type: actiontype.NDC_DETAIL_ALL_MFG, payload: null });
      }
    }
  }, [mfgndc_all]);

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (manu_artbl && manu_arfld) {
      let data;
      if (!filterApply) {
        data = [
          {
            origInvoiceAmt: manu_artbl.totalOrigInvoiceAmount,
            currBalDue: manu_artbl.totalPrincipalDue,
            offsetDue: manu_artbl.totalOffsetDue,
            baseStateAmountDue: manu_artbl.totalBaseStateAmtDue,
            currInvAmt: manu_artbl.totalCurrentInvoice,
            currRoa: manu_artbl.totalCurrentRebateOffsetAmount,
            baseStateRebateAmount: manu_artbl.totalBaseStateRebateAmount,
            amtPaid: manu_artbl.totalprincipalPaid,
            offsetPaidAmt: manu_artbl.totaloffSetPaid,
            baseStateAmountPaid: manu_artbl.totalBaseStateAmountPaid,
            interestPaidAmt: manu_artbl.totalInterestPaid,
            disputedAmt: manu_artbl.totalDisputedAmount,
            unpaidAmt: manu_artbl.totalUnpaidAmont,
            adjustmentAmount: manu_artbl.totalAdjustmentAmount,
            unitChangeAmt: manu_artbl.totalUnitChangeAmount,
            interestDue: manu_artbl.totalInterestDue,
            famPlnAmt: manu_artbl.totalFamilyPlanningAmount,
            fedAmt: manu_artbl.totalFederalAmount,
            stateAmount: manu_artbl.totalStateAmount,
            actions: 'hide',
            isBottomRow: true,
            qtr: manu_arfld?.pgmInfo?.indexOf('All') !== -1 ? 'Total:' : '',
            invoiceDate:
              manu_arfld?.pgmInfo?.indexOf('All') !== -1 ? '' : 'Total:',
          },
        ];
      } else {
        data = [
          {
            origInvoiceAmt: sum('origInvoiceAmt'),
            currBalDue: sum('currBalDue'),
            offsetDue: sum('offsetDue'),
            baseStateAmountDue: sum('baseStateAmountDue'),
            currInvAmt: sum('currInvAmt'),
            currRoa: sum('currRoa'),
            baseStateRebateAmount: sum('baseStateRebateAmount'),
            amtPaid: sum('amtPaid'),
            offsetPaidAmt: sum('offsetPaidAmt'),
            baseStateAmountPaid: sum('baseStateAmountPaid'),
            interestPaidAmt: sum('interestPaidAmt'),
            disputedAmt: sum('disputedAmt'),
            unpaidAmt: sum('unpaidAmt'),
            adjustmentAmount: sum('adjustmentAmount'),
            unitChangeAmt: sum('unitChangeAmt'),
            interestDue: sum('interestDue'),
            famPlnAmt: sum('famPlnAmt'),
            fedAmt: sum('fedAmt'),
            stateAmount: sum('stateAmount'),
            actions: 'hide',
            isBottomRow: true,
            qtr: manu_arfld?.pgmInfo?.indexOf('All') !== -1 ? 'Total:' : '',
            invoiceDate:
              manu_arfld?.pgmInfo?.indexOf('All') !== -1 ? '' : 'Total:',
          },
        ];
      }
      setPinned(data);
    }
  }, [filterApply, filteredRows]);
  React.useEffect(() => {
    if (manu_artbl && manu_arfld) {
      setLoad(false);
      if (gridApi) gridApi.api.refreshCells();
      let tbldata = manu_artbl.infoList;
      if (manu_arfld.pgmInfo.indexOf('All') !== -1) {
        // setTblRecord(manu_artbl.summaryList);
        const allCol = ARManufacturerColumns.filter(
          (obj) =>
            [
              'Invoice Number',
              'Invoice Status',
              'Invoice Handling',
              'Invoice Date',
              'Collection Letter Sent',
            ].indexOf(obj.headerName) === -1
        );
        setColHeader(allCol);
        dispatch(showSelectAction(true));
      } else {
        setColHeader(ARManufacturerColumns);
        dispatch(showSelectAction(false));
        if (!mfgArFirstLoad) {
          dispatch(mfgARFirstLoad(true));
          commentsCallFn();
        }
        const [drams] = rbt_list?.filter(
          (obj) => obj.rebateProgramCd === manu_arfld.pgmCd
        );
        // if (manu_arfld.qtrInfo.indexOf('DRAMS') !== -1) {
        tbldata = tbldata?.map((obj) => {
          obj.drams = drams?.dramsInvoiceStartQtr;
          obj.bgHighlighterColor = getBgHighlighterColor(obj);
          return obj;
        });
        // }
      }
      setTblRecord(tbldata);
    }
  }, [manu_artbl]);

  React.useEffect(() => {
    if (ar_manu) {
      if (ar_manu.message === 'Success' && ar_manu.status === '001') {
        if (
          ar_manu?.accountReceivableDetailSforSingleMfgGridResponseVOs?.infoList
            ?.length
        ) {
          goToArMfg(props.history, arNavRebate, dispatch);
          dispatch(arMfgFirstLoadAction(false));
        } else {
          setIsDialogOpen(true);
          setDialogText(
            'No outstanding receivables exists for the selected labeler.'
          );
          setLoad(false);
        }
        dispatch({ type: actiontype.AR_MANU_NAV_DATA, payload: null });
      }
    }
  }, [ar_manu]);

  const rowDataTable = tblRecord?.map((obj) => {
    obj.currBalDue = obj.currBalDue ? obj.currBalDue : parseFloat(0).toFixed(2);
    obj.baseStateAmountDue = checkNumber(obj.baseStateAmountDue)
      ? obj.baseStateAmountDue
      : parseFloat(0).toFixed(2);
    obj.currInvAmt = obj.currInvAmt ? obj.currInvAmt : parseFloat(0).toFixed(2);
    obj.currRoa = checkNumber(obj.currRoa)
      ? obj.currRoa
      : parseFloat(0).toFixed(2);
    obj.baseStateRebateAmount = obj.baseStateRebateAmount
      ? obj.baseStateRebateAmount
      : parseFloat(0).toFixed(2);
    obj.paidAmt = obj.paidAmt ? obj.paidAmt : parseFloat(0).toFixed(2);
    obj.offsetPaidAmt = obj.offsetPaidAmt
      ? obj.offsetPaidAmt
      : parseFloat(0).toFixed(2);
    obj.baseStateAmountPaid = obj.baseStateAmountPaid
      ? obj.baseStateAmountPaid
      : parseFloat(0).toFixed(2);
    obj.interestPaidAmt = obj.interestPaidAmt
      ? obj.interestPaidAmt
      : parseFloat(0).toFixed(2);
    obj.disputedAmt = obj.disputedAmt
      ? obj.disputedAmt
      : parseFloat(0).toFixed(2);
    obj.unpaidAmt = obj.unpaidAmt ? obj.unpaidAmt : parseFloat(0).toFixed(2);
    obj.adjustmentAmount = obj.adjustmentAmount
      ? obj.adjustmentAmount
      : parseFloat(0).toFixed(2);
    obj.unitChangeAmt = obj.unitChangeAmt
      ? obj.unitChangeAmt
      : parseFloat(0).toFixed(2);
    obj.interestDue = obj.interestDue
      ? obj.interestDue
      : parseFloat(0).toFixed(2);
    obj.famPlnAmt = obj.famPlnAmt ? obj.famPlnAmt : parseFloat(0).toFixed(2);
    obj.fedAmt = obj.federalamount
      ? obj.federalamount
      : parseFloat(0).toFixed(2);
    obj.stateAmount = obj.stateAmount
      ? obj.stateAmount
      : parseFloat(0).toFixed(2);
    return obj;
  });

  let fourthInfo = `Manufacturer Name: ${manu_arfld?.mfgName}`;
  let firstInfo = `Manufacturer ID: ${manu_arfld?.mfgId}`;
  let thirdInfo = `Rebate Program: ${manu_arfld?.pgmInfo}`;
  let secondInfo = `Quarter Range: ${manu_arfld?.qtrInfo}`;
  let sixthInfo = `Unallocated Balance: ${
    unallocated < 0
      ? `(${formatter.format(-unallocated).replace(/^(\D+)/, '$1 ')})`
      : `${formatter.format(unallocated).replace(/^(\D+)/, '$1 ')}`
  } `;
  let seventhInfo = `URA Used: ${manu_arfld?.useOfficialURA==1?"Official":"Most Recent"}`;

  return (
    <div className="tabs-container ARScreen" data-testid="MfgAccountsRec">
      <CustomSeparator
        parent1="Research"
        parent2={`Manufacturer Accounts Receivable [${activeMfgPgmCode}]`}
      />
      <Spinner load={load} />
      <div className="row">
        {!fullScreen && (
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <TextField
                      id="manufacturerId"
                      label={manufacturerIdLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={manu_arfld?.mfgId}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <TextField
                      id="name"
                      label={nameLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={manu_arfld?.mfgName}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={manu_arfld?.pgmInfo}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <OverlayTrigger
                      placement="top"
                      data-testid="overlay"
                      overlay={renderTooltip}
                    >
                      <TextField
                        id="quarterRange"
                        label={quarterRangeLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          manu_arfld?.qtrInfo?.indexOf('DRAMS') !== -1 ||
                          manu_arfld?.qtrInfo?.indexOf('First') !== -1
                            ? `${manu_arfld?.qtrInfo?.substring(0, 20)}...`
                            : manu_arfld?.qtrInfo
                        }
                      />
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <TextField
                      id="unAllocateBal"
                      label={unallocatedBalanceLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      className={unallocated < 0 ? 'negative-value' : ''}
                      value={`${
                        unallocated < 0
                          ? `(${formatter
                              .format(-unallocated)
                              .replace(/^(\D+)/, '$1 ')})`
                          : `${formatter
                              .format(unallocated)
                              .replace(/^(\D+)/, '$1 ')}`
                      } `}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 ">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={manu_arfld?.useOfficialURA==1?"Official":"Most Recent"}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12 mt-3 panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          {colHeader && colHeader.length > 0 ? (
          <TableGridWithFeatures
            data-testid="manufacturersar-grid"
            fullScreenView={fullScreen}
            persistColumnLayout
            columnStateId={`MfgAccountsRec:${activeMfgPgmCode}`}
            handleFullScreenViewClick={() => setFullScreen(!fullScreen)}
            gridHeight={fullScreen ? '70vh' : viewPortHeight_355}
            columnDefs={colHeader}
            rowData={rowDataTable}
            exportFile
            animateRows
            sideBar={false}
            fileName={ARmanufacturerLabel}
            isScrollOn
            hideColumnsInPdf={
              manu_arfld?.pgmInfo?.indexOf('All') !== -1
                ? ['cc_COMMENTS_EXIST', ...AR_CONST.mfgARHideColumnsInPdf]
                : AR_CONST.mfgARHideColumnsInPdf
            }
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            pinnedBottomRowData={tblRecord?.length ? pinned : undefined}
            gridCall={onGridReady}
            noGlobalSort
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
              sixthInfo,
              seventhInfo,
            }}
          />) : null}
        </div>
      </div>
      <CommonModal
        open={isDialogOpen}
        className="dialog-420"
        viewAction
        viewHeader
        okTitle="Ok"
        onOk={() => setIsDialogOpen(false)}
        childrenComponent={dialogText}
        modalTitle="Manufacturer Accounts Receivable"
        onClose={() => setIsDialogOpen(false)}
      />
      <CommonModal
        open={confimPopup}
        className="dialog-420"
        viewAction
        data-testid="commonModal2"
        viewHeader
        onOk={() => {
          setConfimPopup(false);
          if (confirmPopupData?.callFrom === 'balance')
            updateInvoiceBalancedHandler(undoData);
          else declareInvoiceBankruptHandler(undoData);
        }}
        okTitle="Ok"
        onClose={() => setConfimPopup(false)}
        childrenComponent={confirmPopupData?.popupText}
        closeTitle="Cancel"
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={() => {
            commentsCallFn();
            commentsData(false, '');
          }}
          linkTableName="INVOICE_HEADER"
          corrLinkId={corrLinkId}
          data-testid="commentsCall"
        />
      ) : null}
    </div>
  );
};

export default MfgAccountsRec;
